import type { ParametrosAvancados } from "../../../services/configuracaoDeliveryFornecedor"

export type ParametrosAvancadosModel = ParametrosAvancados

export const ParametrosAvancadosInicial: ParametrosAvancadosModel = {
    fusoHorario: 0,
    horaInicioTurnoDia: 6,
    horaInicioTurnoNoite: 18,
    urlWebHookIntegracao: null,
    authWebHookIntegracao: null,
    percentualMaximoBebidasPagamentoOnline: 30,
    impedirApenasBebidasPagamentoOnline: true,
    pontuarNoDelivery: true,
    permitirBuscaPorAdicionais: false,
    atualizarEtapaAoAssociarEntregador: true,
    permiteTaxaEntregaNoturna: false,
    permiteMinimoEntregaPorBairro: false,
    enviarMensagemDeAvaliacaoPedidoPelaIzza: true,
    enviarListaComTodosOsBairrosAtendidos: true,
    bloquearPagamentoOnlinePrimeiraCompra: false,
    tocarNovoPedidoSite: true,
    permitirApenasPagamentoOnline: false,
    permitirEventoAckSemAceitarPedido: false,
    exibirConfiguracaoAvancadaProduto: false,
    possuiPedidoMesa: false,
}

// Metadados para renderização em loop
export type CampoBoolean = {
    campo: keyof Pick<
        ParametrosAvancadosModel,
        | "impedirApenasBebidasPagamentoOnline"
        | "pontuarNoDelivery"
        | "permitirBuscaPorAdicionais"
        | "atualizarEtapaAoAssociarEntregador"
        | "permiteTaxaEntregaNoturna"
        | "permiteMinimoEntregaPorBairro"
        | "enviarMensagemDeAvaliacaoPedidoPelaIzza"
        | "enviarListaComTodosOsBairrosAtendidos"
        | "bloquearPagamentoOnlinePrimeiraCompra"
        | "tocarNovoPedidoSite"
        | "permitirApenasPagamentoOnline"
        | "permitirEventoAckSemAceitarPedido"
        | "exibirConfiguracaoAvancadaProduto"
        | "possuiPedidoMesa"
    >
    label: string
    descricao?: string
}

export type GrupoCheckboxes = { titulo: string; campos: CampoBoolean[] }

export const GRUPOS_CHECKBOXES: GrupoCheckboxes[] = [
    {
        titulo: "Delivery",
        campos: [
            { campo: "pontuarNoDelivery", label: "Pontuar no delivery" },
            {
                campo: "impedirApenasBebidasPagamentoOnline",
                label: "Impedir pedido apenas com bebidas para pagamento online",
            },
            {
                campo: "permitirApenasPagamentoOnline",
                label: "Permitir apenas pedidos com pagamento online no delivery",
                descricao: "Marque caso queira permitir apenas pagamentos online no delivery do estabelecimento.",
            },
            { campo: "bloquearPagamentoOnlinePrimeiraCompra", label: "Impedir pagamento online na primeira compra" },
            { campo: "permiteTaxaEntregaNoturna", label: "Permite taxa de entrega noturna diferenciada" },
            { campo: "permiteMinimoEntregaPorBairro", label: "Permite mínimo para entrega grátis por bairro" },
        ],
    },
    {
        titulo: "Pedidos e Sistema",
        campos: [
            { campo: "permitirBuscaPorAdicionais", label: "Permitir Busca Por Adicionais No Painel de Pedidos" },
            {
                campo: "atualizarEtapaAoAssociarEntregador",
                label: "Atualizar pedido como Saiu para Entrega ao associar entregador",
            },
            {
                campo: "permitirEventoAckSemAceitarPedido",
                label: "Permitir ACK de evento sem aceitar um pedido (Integração)",
                descricao:
                    "Desmarque caso queira manter o painel de recebimentos da Cliente Fiel em funcionamento mesmo com uma integração ativa.",
            },
            { campo: "tocarNovoPedidoSite", label: "Habilitar som na tela de pedidos do site" },
            {
                campo: "exibirConfiguracaoAvancadaProduto",
                label: "Exibir configurações avançadas de limite de quantidade do produto",
            },
            { campo: "possuiPedidoMesa", label: "Pedido de Mesa" },
        ],
    },
    {
        titulo: "Izza",
        campos: [
            {
                campo: "enviarMensagemDeAvaliacaoPedidoPelaIzza",
                label: "Permitir que a Izza envie link para avaliação do Pedido",
                descricao: "Permite que a Izza envie o link para avaliação quando o pedido for finalizado.",
            },
            {
                campo: "enviarListaComTodosOsBairrosAtendidos",
                label: "Permitir que a Izza envie lista com todos os bairros atendidos",
                descricao: "Permite que a Izza envie lista com todos os bairros atendidos.",
            },
        ],
    },
]
